/* eslint-disable @typescript-eslint/no-empty-function */
import debug from 'debug';
import moment from 'moment';

const log = debug('app:intercom');

declare global {
  interface Window {
    Intercom: any;
    intercomSettings: any;
  }
}

export const bootLoggedUser = (authUser) => {
  try {
    window.Intercom = window.Intercom || (() => {});

    window.Intercom('shutdown');

    window.intercomSettings = {
      api_base: 'https://api-iam.intercom.io',
      app_id: process.env.REACT_APP_INTERCOM_APP_ID,
      user_id: authUser.tutopiyaUserId,
      user_hash: authUser.userHash,
    };

    const userData = {
      app_id: process.env.REACT_APP_INTERCOM_APP_ID,
      name: `${authUser.firstname || ''}${
        authUser.lastname ? ` ${authUser.lastname}` : ''
      }`,
      email: authUser.email,
      user_id: authUser.tutopiyaUserId,
      created_at: moment(authUser.createdAt).unix(),
      Role: authUser.role.name,
      'First Name': authUser.firstname,
      phone: undefined,
      WhatsApp: undefined,
    };

    if (authUser.phoneNumber) {
      userData.phone = authUser.phoneNumber;
      userData.WhatsApp = authUser.phoneNumber;
    }

    window.Intercom('boot', userData);
  } catch (error) {
    log("Couldn't load intercom", error);
  }
};

export const bootVisitor = () => {
  try {
    window.Intercom = window.Intercom || (() => {});

    window.Intercom('shutdown');
    window.Intercom('boot', {
      app_id: process.env.REACT_APP_INTERCOM_APP_ID,
    });
  } catch (error) {
    log("Couldn't load intercom", error);
  }
};

export const logout = () => window.Intercom('shutdown');

export const openChat = () => {
  if (window.Intercom) {
    window.Intercom('show');
  }
};

export const startIntercomChat = (message: string) => {
  if (window.Intercom) {
    window.Intercom('showNewMessage', message);
  }
};
